import React from "react"
import { CardLinkWrapper } from "../elements"

const CardLink = ({children, href}) => {
    //return <CardLinkWrapper to={ href }>{children}</CardLinkWrapper>
    return <CardLinkWrapper href={href}>{children}</CardLinkWrapper>
}
//para que no refresque la página, ÉXITO
export default CardLink
